// dependency-graph-ignore-file
import {
  type Database,
  getOrderWithFallback,
  placeIdsInOrder
} from '@databases/model/database';

import { getNewIndexWithHiddenFields } from '../utils/collab-utils.ts';

interface ReorderFieldParams {
  fieldId: string;
  newIndex: number;
  hiddenFields?: string[];
}

export function reorderField(
  ydb: Database,
  { fieldId, newIndex, hiddenFields }: ReorderFieldParams
): void {
  ydb.mutate((db) => {
    const currentIndex = db.fields.indexOf(fieldId);
    const viewIndex = newIndex > currentIndex ? newIndex - 1 : newIndex;
    const adjustedIndex = getNewIndexWithHiddenFields(newIndex, db.fields, hiddenFields);
    db.reorderField(fieldId, adjustedIndex);

    Object.entries(db.viewOrders).forEach(([viewId, viewOrder]) => {
      const order = getOrderWithFallback(db.fields, viewOrder.fieldOrder);
      db.setViewFieldOrder(
        viewId,
        placeIdsInOrder(order, [fieldId], viewIndex),
        'preserve-ordering-mode'
      );
    });
  });
}
